<div cdkDropList (cdkDropListDropped)="drop($event)">
  <div
    cdkDrag
    cdkDragLockAxis="y"
    *ngFor="let rule of filterStepCopy?.choices?.rules; let index = index; let last = last"
  >
    <mat-icon cdkDragHandle class="grabbable" *ngIf="filterStepCopy.choices.rules.length > 1">drag_indicator</mat-icon>
    <automata-workflow-step-rules-filter
      [rule]="rule"
      [taskDefinitionId]="getTaskDefinitionId()"
      [showClose]="filterStepCopy?.choices?.rules.length > 1 || showClose"
      [displayInternalFilters]="displayInternalFilters"
      [fallbackNextStep]="commonMergeNode"
      (removedCondition)="remove(index)"
      [canChangeTaskDefinition]="filterStepCopy?.choices?.rules?.length === 1"
      [currentStepData]="filterStepCopy.data"
      (newTaskDefinitionId)="setNewTaskDefinitionId($event, index)"
      (newData)="setStepData($event)"
      [predecessorOutputParams]="predecessorOutputParams"
      [currentWorkflowStepId]="rulesFilterComponents?.first?.filterSubgroupControl?.value"
      [selectedTaskDefinitionId]="selectedTaskDefinitionId"
      [isGoal]="isGoal"
    ></automata-workflow-step-rules-filter>
  </div>
</div>

<a (click)="addBranch()" class="more" *ngIf="allowMultiBranching">
  {{ 'AUTOMATIONS.EDITOR.BRANCH.PLUS_ADD_ANOTHER' | translate }}
</a>
